/**
 * Game state store
 * Manages the current game state including phase, scores, and timer
 */

import { writable } from 'svelte/store';
import type { GameState, PromptOption } from '@blather/shared';

interface GameStoreState {
  gameState: GameState | null;
  availablePrompts: PromptOption[];
  loading: boolean;
  error: string | null;
}

function createGameStore() {
  const { subscribe, set, update } = writable<GameStoreState>({
    gameState: null,
    availablePrompts: [],
    loading: false,
    error: null,
  });

  return {
    subscribe,

    setGameState(gameState: GameState | null) {
      update((state) => ({ ...state, gameState, error: null }));
    },

    setAvailablePrompts(prompts: PromptOption[]) {
      update((state) => ({ ...state, availablePrompts: prompts }));
    },

    setLoading(loading: boolean) {
      update((state) => ({ ...state, loading }));
    },

    setError(error: string | null) {
      update((state) => ({ ...state, error, loading: false }));
    },

    clearError() {
      update((state) => ({ ...state, error: null }));
    },

    reset() {
      set({
        gameState: null,
        availablePrompts: [],
        loading: false,
        error: null,
      });
    },
  };
}

export const gameStore = createGameStore();
